/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-const */
import { ChangeDetectionStrategy, Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { DialogModule } from 'primeng/dialog';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { StyleClassModule } from 'primeng/styleclass';
import { ButtonModule } from 'primeng/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'primeng/popover';
import { AvatarModule } from 'primeng/avatar';

import { ToastMessageService } from '@fitness-force/api';

import { AppErrors, ErrorMsgComponent } from '@fitness-force/errors';
import { ClientSubscriptionFreezeResponse, ClientSubscriptionFreezeTimeLineResponse, PaymentTimeline, UpdateClientSubscriptionFreezeRequest } from '@fitness-force/models';
import { ClientSubscriptionFreezeStatus, PlanCategory } from '@fitness-force/enum';
import { FreezeService, TimeconversionService } from '@fitness-force/api';
import { COMPANY_INFO, TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { ErrorsComponent,} from '@fitness-force/common/errors'

import { BehaviorSubject } from 'rxjs';
import { Store } from '@ngrx/store';

@Component({
  selector: 'freeze-edit',
  templateUrl: './freeze-edit.component.html',
  styleUrls: ['./freeze-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [ToastMessageService],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    DatePickerModule,
    SelectModule,
    StyleClassModule,
    ButtonModule,
    PopoverModule,
    AvatarModule,
    ErrorMsgComponent,
    ErrorsComponent,
    TranslateModule
  ]
})
export class FreezeEditComponent implements OnInit {
  @Input('visible') visible = false;
  @Input('freeze') freeze$: BehaviorSubject<ClientSubscriptionFreezeResponse>;
  @Output('hidePopup') hidePopup = new EventEmitter<boolean>();

  fg: UntypedFormGroup;
  freezeTimeline$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  clientId$: BehaviorSubject<number> = new BehaviorSubject(0);
  tenantId$: BehaviorSubject<number> = new BehaviorSubject(0);
  isUpdated$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  //#region error popup
  error = new BehaviorSubject(null as AppErrors | null);
  showErrorPopup = new BehaviorSubject(false);
  errorMessages = [] as any;
  HideErrorPopup(event: any) {
    this.showErrorPopup?.next(false);
    this.errorMessages = [];
    this.error.next(null);
  }
  //#endregion error popup

  constructor(
    private freezeService: FreezeService,
    private translate: TranslateService,
    private store: Store,
    private fb: UntypedFormBuilder,
    private toastMessageService: ToastMessageService,
    private timeservice:TimeconversionService
  ) { }

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.store.select(TENANTS_INFO).subscribe((tenant) => {
      this.tenantId$.next(tenant.selected_tenant.id);
    });

    this.store.select(COMPANY_INFO).subscribe((responseData) => {
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });

    if (this.IsRecurringSubscription) {
      this.fg = this.fb.group({
        selectedfreezeattempt: new UntypedFormControl('', [Validators.required]),
      });
    }
    else {
      this.fg = this.fb.group({
        startdate: new UntypedFormControl( this.timeservice.ConvertUTCToLocalDateTime(this.freeze$.value?.start_date!), [Validators.required]),
        enddate: new UntypedFormControl(this.timeservice.ConvertUTCToLocalDateTime(this.freeze$.value?.end_date!!), [Validators.required]),
      });

      if(this.freeze$.value.status == ClientSubscriptionFreezeStatus.FreezeInprogress || this.freeze$.value.status?.toString() == ClientSubscriptionFreezeStatus[ClientSubscriptionFreezeStatus.FreezeInprogress])
      {
        this.StartDateControl?.clearValidators();
      }
    }

    this.fg.addControl("comment", new UntypedFormControl(this.freeze$.value?.comment!, [Validators.required]));

    this.clientId$.next(this.freeze$.value?.client_id || 0);

    this.freezeService.GetFreezeTimeline(this.clientId$.value, this.freeze$.value?.client_subscription.id || 0).subscribe({
      next: (freezeTimeline: PaymentTimeline) => {
          let timeline: any[] = [];
          freezeTimeline.invoice_occurance?.forEach((obj) => {
            let newObj: any = obj
            newObj.strDate = this.toDateHtml(this.timeservice.ConvertUTCToLocalDateTime(obj.occurance_start_date));
            newObj.strDateFormat = this.toDate(obj.occurance_start_date);
            if (this.toDate(obj.occurance_start_date) == this.toDate(this.freeze$.value?.start_date || '') && this.toDate(obj.occurance_end_date) == this.toDate(this.freeze$.value?.end_date || '')) {
              newObj.is_frozen = false;
              this.SelectedFreezeAttempt?.setValue(newObj);
            }
            timeline.push(newObj);
          });
          this.freezeTimeline$.next(timeline);
      },
      error: () => {
        this.freezeTimeline$.next(null);
      }
    });
  }


  toDateHtml(d: Date | string): string {
    const dateStr = new Date(d).toDateString();
    const dateStrArr = dateStr.split(' ');
    return `<span>${this.ordinalNumber(dateStrArr[2] as unknown as number)}</span>
    <span> of </span>
    <span>${dateStrArr[1]}</span>
    <span>${dateStrArr[3]}</span>`;
  }

  toDate(d: Date | string): string {
    const dateStr = new Date(d).toDateString();
    const dateStrArr = dateStr.split(' ');
    const s = ['th', 'st', 'nd', 'rd'];
    const v: number = parseInt(dateStrArr[2]) % 100;
    return `${dateStrArr[2].toString() + (s[(v - 20) % 10] || s[v] || s[0]).toString()} of ${dateStrArr[1]} ${dateStrArr[3]}`;
  }

  ordinalNumber(n: number | null | undefined): string {
    if (n) {
      const s = ['th', 'st', 'nd', 'rd'];
      const v: number = n % 100;
      return (
        n.toString() +
        '<sup>' +
        (s[(v - 20) % 10] || s[v] || s[0]).toString() +
        '</sup> '
      );
    } else return '';
  }

  HidePopup() {
    this.hidePopup.emit(this.isUpdated$.value);
    this.visible = false;
  }


  EditFreeze(): void {
    this.fg.markAllAsTouched();
    if (this.fg.valid) {
      let param = {} as UpdateClientSubscriptionFreezeRequest;
      if (this.IsRecurringSubscription) {
        var startDate = new Date(this.SelectedFreezeAttempt?.value.occurance_start_date);
        var endDate = new Date(this.SelectedFreezeAttempt?.value.occurance_end_date);
        startDate.setHours(0, 0, 0);
        endDate.setHours(23, 59, 59);
        param.start_date = this.timeservice.ConvertLocalDateTimeToUTC(this.SelectedFreezeAttempt?.value.occurance_start_date);
        param.end_date = this.timeservice.ConvertLocalDateTimeToUTC(this.SelectedFreezeAttempt?.value.occurance_end_date);
      }
      else {
        var startDate = new Date(this.StartDateControl?.value);
        var endDate = new Date(this.EndDateControl?.value);
        startDate.setHours(0, 0, 0);
        endDate.setHours(23, 59, 59);
        param.start_date = this.timeservice.ConvertLocalDateTimeToUTC(startDate);
        param.end_date = this.timeservice.ConvertLocalDateTimeToUTC(endDate);
      }
      param.comment = this.CommentControl?.value;
      this.freezeService.PutUpdateFreeze(
        this.freeze$.value?.tenant_id,
        this.freeze$.value?.client_id,
        this.freeze$.value?.client_subscription.id,
        this.freeze$.value?.freeze_id,
        param
      ).subscribe({
        next: (res) => {
          if (res) {
            this.isUpdated$.next(true);
            this.translate.get('FREEZE.FREEZE_EDIT.REQUEST_SUCCESS').subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
            this.HidePopup();
          }
        },
        error: (err) => {
          this.error.next(err);
          this.showErrorPopup.next(true);
        }
      });
    }
  }


  get StartDateControl(): AbstractControl | null {
    return this.fg.controls.startdate as AbstractControl;
  }

  get EndDateControl(): AbstractControl | null {
    return this.fg.controls.enddate as AbstractControl;
  }

  get SelectedFreezeAttempt(): AbstractControl | null {
    return this.fg.controls.selectedfreezeattempt as AbstractControl;
  }

  get CommentControl(): AbstractControl | null {
    return this.fg.controls.comment as AbstractControl;
  }

  get IsRecurringSubscription(): boolean {
    const category: PlanCategory | null = this.freeze$.value?.client_subscription.category || null;

    if (category)
      return (
        category == PlanCategory.Contract || category.toString() == PlanCategory[PlanCategory.Contract]
        || category == PlanCategory.PayAsYouGo || category.toString() == PlanCategory[PlanCategory.PayAsYouGo]
      );
    else
      return false;
  }

  get isInProgresFreeze()
  {
    return this.freeze$.value.status == ClientSubscriptionFreezeStatus.FreezeInprogress || this.freeze$.value.status?.toString() == ClientSubscriptionFreezeStatus[ClientSubscriptionFreezeStatus.FreezeInprogress];
  }
}